import { InvitedTeamMemberModel } from './invite-team-form';
import { UserRoleIds, UserRoles } from '../user-roles';

export enum ErrorCode {
  UNKNOWN_ERROR_CONTACT_SUPPORT = 'SS_006',
}

export type StartSignupRequest = {
  email: string;
  recaptcha_token: string;
  redirect_url: string;
};

export type StartSignupResponse = {
  message: string;
};

export type ValidateTokenResponse = {
  valid: boolean;
  action: SignupAction;
};

export type CreateAccountRequest = {
  first_name: string;
  last_name: string;
  company_name?: string;
  password: string;
  send_text_alerts: boolean;
  phone_number?: string;
  token: string;
  recaptcha_token: string;
};

export type CreateAccountInCompanyRequest = Omit<CreateAccountRequest, 'company_name'>;

export type CreateAccountResponse = {
  redirect_url: string;
  company_id: number;
  user_id: number;
  email: string;
};

export type CreateAccountErrorResponse = {
  error_message: string;
  error_code: ErrorCode;
};

export type InviteTeamRequest = {
  invitations: {
    email: string;
    security_level_id: UserRoleIds;
  }[];
};

export type InviteTeamResponse = {
  data: {
    email: string;
    message: string;
    response_code: InviteTeamMemberResponseCode;
    status: number;
  }[];
};

export enum InviteTeamMemberResponseCode {
  INVALID_REQUEST = 'CI_1001',
  INTERNAL_SERVER_ERROR = 'CI_1002',
  SECURITY_LEVEL_ERROR = 'CI_1003',
  USER_EXISTS_IN_COMPANY = 'CI_1004',
  USER_EXISTS_IN_EQUIPMENTSHARE = 'CI_1005',
  INVITATION_SENT = 'CI_1006',
}

export enum SignupAction {
  SELF_SIGNUP = 'self-signup',
  COMPANY_SIGNUP = 'self-signup-company',
  COMPANY_INVITE = 'company-invitation',
}

export enum SignupUrlKeys {
  ACTION = 'action',
  TOKEN = 'token',
  EMAIL = 'email',
  REDIRECT_URL = 'redirectUrl',
  COMPANY_NAME = 'company-name',
}

export interface InviteSubmitData {
  successfulInvites: InvitedTeamMemberModel[];
  invitationResponse: InvitedTeamMemberStatusModel[];
}

export type InvitedTeamMemberStatusModel = {
  email: string;
  status: number;
  role: UserRoles.MANAGER | UserRoles.USER;
};
